import React from 'react'
import { submitReportProgress } from '@/enums/submitReportProgress'
import { Card } from '@/components/cards/card'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'

function AllDoneCard ({ submitProgress }) {
  return submitProgress > submitReportProgress.enum.TicketCreated
    ? <Card dataCy='allDoneCard' bgColor='success' headerText='Reporting.SubmissionDone'>
      <Icon name='bx-check' />
      <Resx name='Reporting.SubmissionDoneText' />
    </Card> : null
}

export { AllDoneCard }



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/submit/allDoneCard.js